import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button/Button';
import TextFit from 'components/TextFit/TextFit';
import LinkButton from 'components/LinkButton/LinkButton';

import AuctionDocumentsModal from './components/AuctionDocumentsModal/AuctionDocumentsModal';
import useBooleanState from 'hooks/useBooleanState/useBooleanState';
import LoginModal from './components/LoginModal/LoginModal';

const LoggedOutActions = () => {
  const { t } = useTranslation();
  const [isAuctionDocumentsModalOpen, openAuctionDocumentsModal, closeAuctionDocumentsModal] = useBooleanState(false);
  const [isLoginModalOpen, openLoginModal, closeLoginModal] = useBooleanState(false);

  return (
    <div className="actions">
      <Button variant="primary" onClick={openLoginModal}>
        <span className="link">{t('pages.prosforaProject.login')}</span>
      </Button>
      <Button variant="secondary" onClick={openAuctionDocumentsModal}>
        <TextFit>{t('pages.prosforaProject.auctionDocuments')}</TextFit>
      </Button>
      <LinkButton variant="black-thick" to="/register">
        <TextFit>{t('pages.prosforaProject.requestAccess')}</TextFit>
      </LinkButton>
      <AuctionDocumentsModal isOpen={isAuctionDocumentsModalOpen} onRequestClose={closeAuctionDocumentsModal} />
      <LoginModal isOpen={isLoginModalOpen} onRequestClose={closeLoginModal} />
    </div>
  );
};

export default LoggedOutActions;
